// Configuration for Guts Multiplayer Client
// Change these values for production deployment

function getServerURL() {
  if (typeof window !== 'undefined') {
    const { origin, hostname } = window.location;
    // Public reverse proxy routes /api and /socket.io to the game server
    if (origin.includes('gutz.sbfchoice.cc') || origin.includes('gutzv2.sbfchoice.cc')) {
      return origin;
    }
    // Local docker client (port 3004) proxies /api and /socket.io via nginx
    if (hostname === '192.168.1.211' || hostname === 'localhost' || hostname === '127.0.0.1') {
      return origin;
    }
  }
  return process.env.REACT_APP_SERVER_URL || "http://192.168.1.211:5000";
}

export const SERVER_URL = getServerURL();
export const API_BASE = `${SERVER_URL}/api`;
export const SOCKET_URL = SERVER_URL;
